import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext.tsx';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/USMONlogo.png';
import profileLogo from '../assets/logo.png';
import { FaChevronDown } from "react-icons/fa6";
import { MdOutlineLogout } from "react-icons/md";
import './HeaderStyle.scss';
import { Modal, Spin } from 'antd';
// import { FloatingLabel, Form, } from "react-bootstrap";
import { TbCurrencyDollar } from "react-icons/tb";
import { FaStethoscope } from "react-icons/fa6";
import { IoMenuOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { apiCall } from '../api/apiRoutes.ts';
import { NetworkInfo } from "../constants/network.ts";
import { message, Skeleton } from 'antd';
import showMessageQueue from '../utils/messageUtils.js';
import Select from 'react-select';

const Header: React.FC = ({ isAuthenticated }: any) => {
  const location = useLocation(); // Hook to get current location
  const [isSticky, setIsSticky] = useState(false); // State for sticky class
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const navigate = useNavigate();
  const { logout, login, user } = useAuth(); // Assuming your AuthContext has a logout function
  const isActive = (path: string) => location.pathname === path;
  const [clients, setClients] = useState([])
  const [users, setUser]: any = useState(null)
  const [currentClient, setCurrentClient] = useState(null)
  const [sessionData, setSessionData] = useState([])
  const [loading, setLoading] = useState(false)
  const [logoutLoader, setLogoutLoader] = useState(false)
  const [messages, contextHolder] = message.useMessage();
  const [licensesData, setLicensesData] = useState([]);
  // Scroll event handler
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLogout = async () => {
    setLogoutLoader(true)
    const storedUser = localStorage.getItem("usmonUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;

    const data: any = {
      access_token: parsedUser?.access_token,
      refresh_token: parsedUser?.refresh_token
    }
    try {
      const response = await apiCall(data, `${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.logout}`, "post", false, false, false);
      if (response?.statusCode === 200) {
        // perform logout actions here
        logout(); // clear authentication context
        setIsLogout(false)
        navigate('/login'); // redirect to login page
        showMessageQueue(messages, "success", response?.message)
        setLogoutLoader(false)
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
        } else {
          localStorage.clear();
        }

      } else {
        setIsLogout(false)
        showMessageQueue(messages, "error", "Failed to logout")
        setLogoutLoader(false)
      }
    } catch (error: any) {
      setIsLogout(false)
      setLogoutLoader(false)
      showMessageQueue(messages, "error", error?.response?.data?.message)
    }
  };

  const setHeaderData = () => {
    const storedUser = localStorage.getItem('usmonUser');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser); // First, parse the whole object
        setTimeout(() => {
          setUser(parsedUser?.user || null); // Then safely access access_token
          const availableClients = parsedUser?.user?.availableClients;
          const currentClientId = Object.keys(parsedUser?.user?.current_client)[0]; // Get the first key from the object
          const foundClient: any = Object.entries(availableClients).map(([id, name]) => ({ id, name })).find(client => client.id === currentClientId); // Compare correctly
          setCurrentClient(foundClient)
          const clientsDropdown: any = Object.entries(availableClients).map(([id, name]) => ({ id, name }));
          setClients(clientsDropdown);
        }, 0);
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    }
  }

  /**
   * setting data in header
   */

  useEffect(() => {
    if (isAuthenticated) {
      setHeaderData();
    }
    const storedUser: any = localStorage.getItem('usmonUser');
    const parsedUser = JSON.parse(storedUser);
    if (parsedUser) getLicensesData(Object.keys(parsedUser?.user?.current_client)[0], parsedUser?.user?.email);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const changeClient = async (client: any) => {
    // switch client api integration
    const data: any = {
      client_id: Number(client)
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.switchClient}`, "post", false, false, false);
      if (response?.statusCode === 200) {
        login(response?.data, "switch-client"); // set authentication state
        setUserLogdata()
        setHeaderData()
        window.dispatchEvent(new Event("storage")); // to detect changes in local storage
        showMessageQueue(messages, "success", response?.message)
        setIsModalOpen(false)
      } else {
        showMessageQueue(messages, 'error', 'Failed to switch an user')
      }
    } catch (error: any) {
      showMessageQueue(messages, 'error', error?.response?.data?.message)
    }
  }

  const setUserLogdata = async () => {
    const storedUser: any = localStorage.getItem('usmonUser');
    const parsedUser = JSON.parse(storedUser); // First, parse the whole object
    const id = parsedUser?.user?.webUserId // Get the first key from the object
    try {
      const data = {
        web_user_id: id
      }
      setLoading(true)
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.sessions}`, "post", false, false, false);
      if (response?.success) {
        let sessions = response?.data
          .map((session: any) => {
            const dateObj = new Date(session?.login_time.replace(" ", "T")); // Convert to Date object
            const formattedDate: any = dateObj.toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric",
            });
            const formattedTime: any = dateObj.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }).toLowerCase();

            return { formattedDate, formattedTime, originalDate: dateObj };
          })
          .sort((a: any, b: any) => b.originalDate.getTime() - a.originalDate.getTime()) // Sorting by timestamp
          .map((session: any) => `${session.formattedDate} \n${session.formattedTime}`);

        setSessionData(sessions)
        setLoading(false)
      } else {
        setLoading(false)
        showMessageQueue(messages, 'error', "Failed to fetch sessions data")
      }
    } catch (error: any) {
      setLoading(false)
      showMessageQueue(messages, 'error', "Failed to fetch sessions data")
    }
  }

  const getLicensesData = async (clientId, userid): Promise<void> => {
    try {
      const queryString = new URLSearchParams({ clientId, userid }).toString();
      const response = await apiCall({}, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.getUserLicenses}?${queryString}`, "get", false, false, false);
      if (response?.success) {
        setLicensesData(response?.data?.licenses);
      } else {
        showMessageQueue(messages, 'error', "Failed to fetch licenses data");
      }
    } catch (error: any) {
      showMessageQueue(messages, 'error', "Failed to fetch licenses data");
    }
  };

  const storedUser: any = localStorage.getItem('usmonUser');
  const parsedUser = JSON.parse(storedUser);
  const isAdminRole = (parsedUser?.isUserAdmin === 'usmon-admin') ? true : false;

  return (
    <>
      {logoutLoader ?
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 9999 }}>
          <Spin size="large" />
        </div>
        :
        <header className={`header ${isSticky ? 'sticky' : ''}`}>
          {contextHolder}
          <Navbar collapseOnSelect expand="lg">
            <Container fluid>
              <Navbar.Brand onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
                <img className='logo' src={logo} alt="USMON Logo" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" as="div">
                <IoMenuOutline className='toggle-icon' />
                <IoMdClose className='close-icon' />
              </Navbar.Toggle>
              {isAuthenticated ?
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className='menu-box'>
                    <div className='dropdown-Box mobile-show'>
                      <div className='dropdown-profile'>
                        <img src={profileLogo} alt="USMON Logo" style={{ height: '40px' }} />
                      </div>
                      <div className='dropdown-detail'>
                        <h4>{users?.email}</h4>
                        <h5>{currentClient?.name}</h5>
                      </div>
                    </div>


                    <Link className={`menu-link ${isActive('/home') ? 'active' : ''}`} to="/home">
                      <span>Home</span>
                    </Link>
                    {(isAdminRole || (licensesData && licensesData.length > 0)) &&
                      <Link className={`menu-link ${isActive('/dashboard') ? 'active' : ''}`} to="/dashboard">
                        <span>Dashboards</span>
                      </Link>}
                    <Link className={`menu-link ${isActive('/licenses') ? 'active' : ''}`} to="/licenses">
                      <span>Licenses</span>
                    </Link>

                    {
                      user?.isUserAdmin === 'usmon-admin' &&
                      <Link className={`menu-link ${isActive('/users') ? 'active' : ''}`} to="/users">
                        <span>Users</span>
                      </Link>
                    }

                    <Link className="menu-link mobile-show" to="/licenses" onClick={() => setIsModalOpen(true)}>
                      <span>View or Switch profile</span>
                    </Link>
                    <Link className="menu-link mobile-show" to="/" onClick={() => setIsLogout(true)}>
                      <span>Logout</span> <MdOutlineLogout />
                    </Link>
                  </Nav>

                  <Nav>
                    <Dropdown className='user-dropdown mobile-hide'>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <div className='dropdown-Box'>
                          <div className='dropdown-profile'>
                            <img src={profileLogo} alt="USMON Logo" style={{ height: '40px' }} />
                          </div>
                          <div className='dropdown-detail'>
                            <h4>{users?.email}</h4>
                            <h5>{currentClient?.name}</h5>
                          </div>
                          <span className='icon-down'><FaChevronDown /></span>
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => { setIsModalOpen(true); setUserLogdata() }}>View or Switch profile</Dropdown.Item>
                        <Dropdown.Item onClick={() => setIsLogout(true)}>
                          Logout <MdOutlineLogout />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav>
                </Navbar.Collapse>
                :
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className='menu-box without-login'>
                    <Link className={`menu-link ${isActive('/home') ? 'active' : ''}`} to="https://www.usmon.com/">
                      <span>Go to usmon.com</span>
                    </Link>
                    <Link className={`menu-link ${isActive('/dashboard') ? 'active' : ''}`} to="/login">
                      <span>Login</span>
                    </Link>
                  </Nav>
                </Navbar.Collapse>
              }
            </Container>
          </Navbar>

          <Modal
            className='MyProfile-modal'
            title="My Profile"
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            centered
          >
            <div className='user-profile-box'>
              <div className='profile-img'> <img src={profileLogo} alt="Logo" /> </div>
              <div className='profile-detail'>
                <h3>{users?.email}</h3>
                <h5>{currentClient?.name}</h5>
              </div>
            </div>

            <div className='user-profile-inner'>
              <div className='input-wrap profile-InputWrap'>
                <label className='label-text'>PROFILE</label>
                <p>You can switch between your different profiles below</p>
                <Select
                  options={clients.map((client: any) => ({
                    value: client.id,
                    label: client.name,
                  }))}
                  onChange={(selectedOption) => changeClient(selectedOption?.value)}
                  defaultValue={
                    currentClient
                      ? { value: currentClient.id, label: currentClient.name }
                      : null
                  }
                  placeholder="Search or select a profile"
                  isSearchable
                />
              </div>
              {/* <div className='input-wrap profile-InputWrap'>
                <label className='label-text'>PROFILE</label>
                <p>You can switch between your different profiles below</p>
                <FloatingLabel controlId="floatingSelect" label="Profile selected">
                  <Form.Select onChange={(e) => changeClient(e.target.value)} aria-label="Profile selected" defaultValue={currentClient?.id}>
                    {clients.map((client: any) => (
                      <option key={client.id} value={client.id}>
                        {client.name}
                      </option>
                    ))}
                  </Form.Select>
              </FloatingLabel>
            </div> */}

              {licensesData && licensesData.length > 0 && (
                <div className='input-wrap your-Licenses'>
                  <label className='label-text'>YOUR LICENSES</label>
                  <div className='Licenses-plan-boxes'>
                    {licensesData.map((licenseId, idx) => {
                      if (licenseId === 10001) {
                        return (
                          <div className='plan-box' key={idx}>
                            <div className='plan-icon'>
                              <FaStethoscope />
                            </div>
                            <h4>basic</h4>
                          </div>
                        );
                      } else if (licenseId === 10002) {
                        return (
                          <div className='plan-box' key={idx}>
                            <div className='plan-icon'>
                              <TbCurrencyDollar className='icon-img' />
                            </div>
                            <h4>plus</h4>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </div>
                </div>
              )}

              <div className='input-wrap activity-history'>
                <label className='label-text'>ACTIVITY HISTORY</label>
                <div className='activity-boxes'>
                  {loading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                      <Skeleton key={index} active avatar paragraph={{ rows: 2 }} />
                    ))
                  ) : (sessionData?.slice(0, 5).reverse()?.map((session: any, index: any) => {
                    const [date, time] = session.split('\n');
                    return (
                      <div className='activity-list' key={index}>
                        <h4>{date} <span>session</span></h4>
                        <h4>{time}</h4>
                      </div>
                    )
                  }
                  ))}
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            className='logout-modal'
            title="Log Out Confirmation"
            open={isLogout}
            onOk={handleLogout}
            onCancel={() => setIsLogout(false)}
            centered
          >
            <p>Are you sure you want to log out?</p>
            <div className='modal-footer'>
              <button type="button" className="primary-btn cancel" onClick={() => setIsLogout(false)}>
                <span> Cancel </span>
              </button>
              <button type="button" className="primary-btn" onClick={handleLogout}>
                <span>Logout</span>
              </button>
            </div>
          </Modal>
        </header>}
    </>
  );
};

export default Header;